// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__Btpa6","label":"SetPasswdForm_label__3FLW4"};